import translationEN from './en.json'
import translationES from './es.json'
import translationPT from './pt.json'

export const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  pt: {
    translation: translationPT,
  }
}
